import config from "@/config"
import { Auth } from "@/utils/amplify-compat"
import {
  CognitoIdentityProviderClient,
  paginateListUsers,
} from "@aws-sdk/client-cognito-identity-provider"

const getDefaultState = () => ({
  users: [],
  loading: false,
})

const state = getDefaultState()

const getters = {
  users: (state) => state.users,
  loading: (state) => state.loading,
  user: (state) => (sub) => state.users.find((u) => u.sub === sub),
}

const actions = {
  async getUsers({ commit }) {
    commit('setLoading', true)
    try {
      const creds = await Auth.currentCredentials()
      const client = new CognitoIdentityProviderClient({
        region: config.region,
        credentials: Auth.essentialCredentials(creds),
      })

      const paginator = paginateListUsers(
        { client },                               // paginator config
        { UserPoolId: config.userPoolId, Limit: 60 } // request input
      )

      const all = []
      for await (const page of paginator) {
        for (const u of page.Users || []) {
          const flat = { ...u }
          if (u.Attributes) {
            for (const attr of u.Attributes) flat[attr.Name] = attr.Value
            delete flat.Attributes
          }
          flat.displayName = flat.name || flat.email || flat.Username
          all.push(flat)
        }
      }

      // Example client-side filter: hide disabled only (keep FORCE_CHANGE_PASSWORD, etc.)
      const visible = all.filter(u => u.Enabled !== false)
      visible.sort((a, b) => String(a.displayName).localeCompare(String(b.displayName)))

      commit('setUsers', visible)
    } catch (e) {
      console.error('[users/getUsers] failed:', e)
    } finally {
      commit('setLoading', false)
    }
  },

  startLoading({ commit }) {
    commit("setLoading", true)
  },
  endLoading({ commit }) {
    commit("setLoading", false)
  },
  resetState({ commit }) {
    commit("resetState")
  },
}

const mutations = {
  setUsers(state, payload) {
    state.users = payload
  },
  addUser(state, user) {
    state.users.push(user)
  },
  setLoading(state, loading) {
    state.loading = loading
  },
  resetState(state) {
    Object.assign(state, getDefaultState())
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
